import consola from "consola";

export const useLogger = (logNamespace: string) => {
  const runtimeConfig = useRuntimeConfig()
  consola.level = parseInt(runtimeConfig.public.logLevel);
  return consola.withTag(logNamespace || "app");
}

export default useLogger;
